export default "/images/12442dfa4720ea33a40c09f171b7407f.jpg";